import type { ComponentPropsWithoutRef } from 'react';
import useTranslation from 'next-translate/useTranslation';
import clsx from 'clsx';
import Icon from '@/components/base/Icon';

type RetweetBadgeProps = ComponentPropsWithoutRef<'span'> & {
    withText?: boolean;
    isExport?: boolean;
};
export const RetweetBadge = ({
    className,
    withText = true,
    isExport = false,
    ...restProps
}: RetweetBadgeProps) => {
    const { t } = useTranslation('commons');

    return (
        <span
            className={clsx(
                'inline-flex items-center space-x-1 rounded bg-icoGreen-100 px-2 py-1 text-icoGreen',
                className,
                { 'dark:bg-icoGreen/20': !isExport }
            )}
            aria-label="retweet-badge"
            {...restProps}>
            <Icon icon="retweet" />
            {withText ? <span aria-label="retweet">{t('retweet')}</span> : null}
        </span>
    );
};
